import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";

import { NzThAddOnComponent } from "ng-zorro-antd/table";
import { UiTableFilterList, UiTableFilterValue, UiTableSortOrder } from "@webapp/ui/table/table.models";
import { UiTableFilterFn, UiTableSortFn } from "@webapp/ui/table/utils/table.utils";

@Component({
  selector: "th[uiColumnKey], th[uiSortFn], th[uiSortOrder], th[uiFilters], th[uiShowSort], th[uiShowFilter], th[uiCustomFilter]",
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "th-addon.component.html",
})
export class UiThAddOnComponent<T> extends NzThAddOnComponent<T> {
  @Input("uiColumnKey") public nzColumnKey?: string;
  @Input("uiFilterMultiple") public nzFilterMultiple = true;
  @Input("uiSortOrder") public nzSortOrder: UiTableSortOrder = null;
  @Input("uiSortPriority") public nzSortPriority: number | boolean = false;
  @Input("uiSortDirections") public nzSortDirections: UiTableSortOrder[] = ["ascend", "descend", null];
  @Input("uiFilters") public nzFilters: UiTableFilterList = [];
  @Input("uiSortFn") public nzSortFn: UiTableSortFn<T> | boolean | null = null;
  @Input("uiFilterFn") public nzFilterFn: UiTableFilterFn<T> | boolean | null = null;
  @Input("uiShowSort") @InputBoolean() public nzShowSort = false;
  @Input("uiShowFilter") @InputBoolean() public nzShowFilter = false;
  @Input("uiCustomFilter") @InputBoolean() public nzCustomFilter = false;
  @Output("uiCheckedChange") public readonly nzCheckedChange = new EventEmitter<boolean>();
  @Output("uiSortOrderChange") public readonly nzSortOrderChange = new EventEmitter<string | null>();
  @Output("uiFilterChange") public readonly nzFilterChange = new EventEmitter<UiTableFilterValue>();
}
